import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { searchRobots } from './redux/reducers'
import 'tachyons';

const store = createStore(searchRobots);


ReactDOM.render(
                  <Provider store={store}>
                    <App />
                  </Provider>, document.getElementById('root')
                );


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
